<template>
  <div class="wrapper materials">
    <div class="level-header materials-header">
      <div class="level__counter">1.</div>
      <div class="level__title materials__title">
        ТРАДИЦИОННЫЕ СТРОИТЕЛЬНЫЕ МАТЕРИАЛЫ
      </div>
    </div>

    <div class="materials-task materials-zone dropArea">
      <div class="explain-wrapper materials-explain-area">
        <div class="explain materials-explain aspen">
          <div class="explain__title">Осина</div>
          <div class="explain__desc">Осиновый лемех, уложенный вразбежку и внахлест, формирует
            изогнутые покрытия куполов и шатров
          </div>
          <div class="explain-line">
            <svg width="127" height="286" viewBox="0 0 127 286" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M108 1.2157L107.065 0.862351L107.309 0.215698H108V1.2157ZM1.93549 284.853C1.74034 285.37 1.16331 285.631 0.646652 285.435C0.129997 285.24 -0.130638 284.663 0.0645065 284.147L1.93549 284.853ZM126.5 2.2157H108V0.215698H126.5V2.2157ZM108.935 1.56905L1.93549 284.853L0.0645065 284.147L107.065 0.862351L108.935 1.56905Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain spruce">
          <div class="explain__title">Ель</div>
          <div class="explain__desc">
            Еловые слеги удерживали тесовые пластины, образовывали верхнюю сторону кровли
          </div>
          <div class="explain-line">
            <svg width="196" height="513" viewBox="0 0 196 513" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M174.118 1.5V0.5H173.4L173.17 1.17968L174.118 1.5ZM0.55269 511.68C0.375783 512.203 0.656497 512.77 1.17968 512.947C1.70287 513.124 2.2704 512.844 2.44731 512.32L0.55269 511.68ZM196 0.5H174.118V2.5H196V0.5ZM173.17 1.17968L0.55269 511.68L2.44731 512.32L175.065 1.82032L173.17 1.17968Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain equally spruce">
          <div class="explain__title">Ель</div>
          <div class="explain__desc">
            Еловые слеги удерживали тесовые пластины, образовывали верхнюю сторону кровли
          </div>
          <div class="explain-line">
            <svg width="143" height="211" viewBox="0 0 143 211" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.5 1L25.3721 0.510633L25.0855 0H24.5V1ZM140.628 209.989C140.898 210.471 141.508 210.642 141.989 210.372C142.471 210.102 142.642 209.492 142.372 209.011L140.628 209.989ZM0.5 2H24.5V0H0.5V2ZM23.6279 1.48937L140.628 209.989L142.372 209.011L25.3721 0.510633L23.6279 1.48937Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain birch">
          <div class="explain__title">Береза (береста)</div>
          <div class="explain__desc">
            Сшитая полотнищами береста служила дополнительным изолирующим материалом кровли
          </div>
          <div class="explain-line">
            <svg width="143" height="211" viewBox="0 0 143 211" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.5 1L25.3721 0.510633L25.0855 0H24.5V1ZM140.628 209.989C140.898 210.471 141.508 210.642 141.989 210.372C142.471 210.102 142.642 209.492 142.372 209.011L140.628 209.989ZM0.5 2H24.5V0H0.5V2ZM23.6279 1.48937L140.628 209.989L142.372 209.011L25.3721 0.510633L23.6279 1.48937Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain equally birch">
          <div class="explain__title">Береза (береста)</div>
          <div class="explain__desc">
            Сшитая полотнищами береста служила дополнительным изолирующим материалом кровли
          </div>
          <div class="explain-line">
            <svg width="196" height="513" viewBox="0 0 196 513" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M174.118 1.5V0.5H173.4L173.17 1.17968L174.118 1.5ZM0.55269 511.68C0.375783 512.203 0.656497 512.77 1.17968 512.947C1.70287 513.124 2.2704 512.844 2.44731 512.32L0.55269 511.68ZM196 0.5H174.118V2.5H196V0.5ZM173.17 1.17968L0.55269 511.68L2.44731 512.32L175.065 1.82032L173.17 1.17968Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain pine">
          <div class="explain__title">Сосна</div>
          <div class="explain__desc">
            Смолистые, ровные и прямые бревна хвойных пород образуют большую часть вертикальных стен
            сруба. Долговечные и надежные, они дополнительно ароматизировали воздух внутри помещения
          </div>
          <div class="explain-line">
            <svg width="292" height="217" viewBox="0 0 292 217" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M149.502 1.00024L150.338 0.450491L150.041 0.000244141H149.502V1.00024ZM290.165 216.55C290.468 217.011 291.088 217.139 291.55 216.836C292.011 216.532 292.139 215.912 291.835 215.45L290.165 216.55ZM0 2.00024H149.502V0.000244141H0L0 2.00024ZM148.667 1.55L290.165 216.55L291.835 215.45L150.338 0.450491L148.667 1.55Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain materials-explain stone">
          <div class="explain__title">Камень</div>
          <div class="explain__desc">
            Фундамент из бута позволял поднять постройку над землей, создать защитную воздушную
            прослойку и сохранить нижние венцы сруба от гниения
          </div>
          <div class="explain-line">
            <svg width="126" height="133" viewBox="0 0 126 133" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M107.582 1V0H107.106L106.806 0.368893L107.582 1ZM0.224304 131.369C-0.124247 131.797 -0.0595119 132.427 0.368893 132.776C0.797298 133.124 1.42715 133.06 1.7757 132.631L0.224304 131.369ZM126 0H107.582V2H126V0ZM106.806 0.368893L0.224304 131.369L1.7757 132.631L108.357 1.63111L106.806 0.368893Z"
                fill="black"/>
            </svg>
          </div>
        </div>
      </div>
      <div v-for="task in tasks"
           :key="task.id"
           :class="task"
           :data-compare="task"
           :data-equally="computeCompareName(task)"
           class="materials__drop dropzone">
        <div class="queryMark">
          ?
        </div>
      </div>
    </div>
    <div class="materials-answers dropzone draggable-dropzone--occupied dragArea">
      <div v-for="answer in answers"
           :class="[answer.name]"
           :data-compare="answer.name"
           :data-equally="answer.equally"
           :hasPoint="answer.hasPoint"
           class="answer isDraggable">
        <div>
          <img :src="require('@/img/' + answer.image)" alt="">
          <div class="answer__name">
            {{ answer.caption }}
          </div>
        </div>

      </div>
    </div>
    <div class="task-block">
      <div class="task-block__title">
        Укажите, из каких материалов изготовлены части часовни
      </div>
      <div class="task-block__caption">
        Перетащите мышью каждый из материалов на картинку здания в соответствующие слоты
      </div>
    </div>
    <transition name="fade"
                :duration="400">
      <div class="finished-wrapper"
           v-if="levelFinished">
        <div class="finished__caption">Отлично!</div>
        <button @click="$emit('next-level', 'structures')"
                class="levelControl next-level">
          продолжить
        </button>
      </div>
    </transition>
    <footer class="footer">
      <div class="footer__logo">
        <img src="../img/kizhi_logo.png" alt="">
      </div>
      <div class="footer__copyright">
        © 2019 Государственный историко-архитектурный и этнографический музей-заповедник «Кижи»
      </div>
    </footer>
    <!--Core components-->
    <level-core :tasks="tasks"
                :answers="answers"
                :explanation="'explain'"
                :answerOffset="[-12, 114]"
                @level-finished="onLevelFinished"
                @calculate-points="$emit('calculate-points', $event)"
    ></level-core>
  </div>
</template>

<script>
    import {Droppable} from '@shopify/draggable';
    import levelCore from './level-сore.vue';

    export default {
        components: {
            levelCore,
        },
        data() {
            return {
                levelPoints: 0,
                levelFinished: false,
                tasks: ['aspen', 'pine', 'spruce', 'stone', 'birch'],
                answers: [
                    {name: 'aspen', image: 'm_osina.png', caption: 'Осина', hasPoint: true,},
                    {name: 'pine', image: 'm_sosna.png', caption: 'Сосна', hasPoint: true},
                    {
                        name: 'birch',
                        image: 'm_bereza.png',
                        caption: 'Береза (береста)',
                        hasPoint: true,
                        equally: true,
                    },
                    {name: 'stone', image: 'm_kamen.png', caption: 'Камень', hasPoint: true},
                    {
                        name: 'spruce',
                        image: 'm_el.png',
                        caption: 'Ель',
                        hasPoint: true,
                        equally: true
                    },
                ],
            };
        },

        methods: {
            onLevelFinished(result) {
                this.levelFinished = result;
            },
            computeCompareName: function (name) {
                switch (name) {
                    case 'birch':
                        return true;
                    case 'spruce':
                        return true;
                }
            },
        },
        watch: {},
        computed: {},
        updated() {
        },
        /*mounted() {
            const containers = document.querySelectorAll('.dropzone');
            const maindropArea = document.querySelector('.materials-answers');
            const containerCapacity = 5;
            const classes = {
                draggable: 'StackedListItem--isDraggable',
                capacity: 'draggable-dropzone--occupied',
            };
            if (containers.length === 0) {
                return false;
            }

            const droppable = new Droppable(containers, {
                draggable: '.isDraggable',
                dropzone: '.dropzone',
                mirror: {
                    constrainDimensions: true,
                    cursorOffsetX: -12,
                    cursorOffsetY: 114
                },
            });
            let currentSourceItem;
            let currentSourceContainer;
            let dropzoneContainer
            let draggedCompareName;
            let droppedCompareName;
            let compareEqually;
            let equally1;
            let equally2;

            // ['outside', 'inside']
            let dragState = null;
            // ['resolve', 'reject']
            let dragResult = 'reject';


            droppable.on('drag:start', (evt) => {
                dragState = null;
                dragResult = null;
                currentSourceItem = evt.originalSource;
                currentSourceContainer = evt.sourceContainer;
                draggedCompareName = currentSourceItem.dataset.compare;
                /!*if (currentSourceContainer.closest('.dropArea')) {
                    evt.cancel();
                }*!/
            });
            droppable.on('drag:over', (evt) => {
                let overContainerClasses = evt.overContainer.classList;
                if (!overContainerClasses.contains('dragArea')) {
                    dragState = 'inside';
                }
            });
            droppable.on('drag:out', (evt) => {
                dragState = 'outside';
            });
            droppable.on('drag:out:container', (evt) => {
                dragState = 'outside'
            })
            droppable.on('droppable:dropped', (evt) => {
                dragState = 'inside';
                dragResult = 'resolve';
                droppedCompareName = evt.dropzone.dataset.compare;
                equally1 = evt.dropzone.dataset.equally;
                equally2 = currentSourceItem.dataset.equally;
                let compareResult = this.compareDragNames(draggedCompareName, droppedCompareName)
                let equallyResult = this.compareEqually(equally1, equally2);
                if ((!compareResult) && !equallyResult) {
                    dragResult = 'reject';
                    evt.cancel();
                }

            });
            droppable.on('droppable:stop', (evt) => {
                droppedCompareName = evt.dropzone.dataset.compare;
                dropzoneContainer = evt.dropzone.parentNode;
                let dropzoneClasses = evt.dropzone.classList;
                // Add class only for dropzone 'container'
                if (dragState === 'inside' && dragResult === 'reject') {
                    this.lowerPoint(draggedCompareName);
                }
                if (dropzoneContainer.classList.contains('dropArea')) {
                    dropzoneClasses.toggle('afterDrop', true);
                    this.showGuessed(draggedCompareName, dropzoneClasses);
                    this.answersLeft -= 1;
                }
            })

        },*/
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>


При сборке не обошлось без сложностей. Болты не качественные, и быстро срывается резьба. Но если не торопиться и закручивать болты по диагонали с обоих сторон,
или собирать его в двоем, то будет легче. Газлифт не самый качественный, через полгода начинает поскрипывать,
но в целом за свою цену работает отлично, главное вовремя смазывать.
Механизм покачивания отличный. Колесики спустя почти год отлично ездят, не застревают. Подлокотники хоть и кажутся большими, но на деле отлично подходят под стандартный стол.
